<unavailable-hint
  *ngIf="unavailable"
  [top]="expanded ? '-5px' : '10px'"
  right="-7px"
/>

<span class="label-title" *ngIf="label" [ngClass]="{ 'dark-text': disabled && expanded }">{{label}}</span>
<ion-icon
  class="label-icon"
  *ngIf="!label"
  [src]="disabled && expanded ? 'assets/climate-union-controll-disabled.svg' : 'assets/climate-union-controll.svg'"
  [ngClass]="{ 'dark-text': disabled && expanded }"
></ion-icon>

<div class="ring ring-outer" [ngClass]="{ 'disabled': disabled }">
  <div class="ring ring-half">
    <div class="ring ring-inner">
      <div class="display">
        <span class="display-text">{{ getValue() }}</span>
        <span class="display-units" *ngIf="value && !unavailable">°F</span>
      </div>
    </div>
  </div>
</div>

<span
  *ngIf="expanded"
  class="label-set-to-label"
  [ngClass]="{ 'disabled': !setToValue }"
>{{ setToTemp }}</span>
<!-- >{{ setToValue ? setToValue : (setToValue === 0 ? 'OFF' : '–––') }}</span> -->
